/**
 * 在线取号
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'
// 在线取号
// 接口地址
Mock.mock(/\/meal\/numbers/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'number_status': [
      {
        'status': 0,
        'is_noticed': 0,
        'number': 0,
        'order_id_range': 1,
        'is_choice': false
      },
      {
        'status': 0,
        'is_noticed': 1,
        'number': 1,
        'order_id_range': '1-2',
        'is_choice': false
      },
      {
        'status': 0,
        'is_noticed': 0,
        'number': 2,
        'order_id_range': '1-2',
        'is_choice': false
      },
      {
        'status': 0,
        'is_noticed': 1,
        'number': 3,
        'order_id_range': '3-8',
        'is_choice': false
      },
      {
        'status': 0,
        'is_noticed': 0,
        'number': 4,
        'order_id_range': '3-8',
        'is_choice': false
      },
      {
        'status': 0,
        'is_noticed': 0,
        'number': 5,
        'order_id_range': '3-8',
        'is_choice': false
      },
      {
        'status': 0,
        'is_noticed': 0,
        'number': 6,
        'order_id_range': '3-8',
        'is_choice': false
      },
      {
        'status': 0,
        'is_noticed': 1,
        'number': 7,
        'order_id_range': '3-8',
        'is_choice': false
      },
      {
        'status': 0,
        'is_noticed': 1,
        'number': 8,
        'order_id_range': '3-8',
        'is_choice': false
      },
      {
        'status': 0,
        'is_noticed': 0,
        'number': 9,
        'order_id_range': '9',
        'is_choice': false
      },
      {
        'status': 0,
        'is_noticed': 1,
        'number': 10,
        'order_id_range': '10',
        'is_choice': false
      },
      {
        'status': 0,
        'is_noticed': 0,
        'number': 11,
        'is_choice': false
      },
      {
        'status': 0,
        'is_noticed': 1,
        'number': 12,
        'order_id_range': 5,
        'is_choice': false
      },
      {
        'status': 0,
        'is_noticed': 0,
        'number': 13,
        'order_id_range': 5,
        'is_choice': false
      }
    ],
    'page': 1,
    'item_per_page': 10
  }
})
